var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.layout == "purple"
      ? _c("div", { staticClass: "feature-purple" }, [
          _c("div", { staticClass: "feature-purple__wrapper row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h4", { staticClass: "feature-purple__title" }, [
                _vm._v(_vm._s(_vm._f("trans")("st_public.featured_on")))
              ])
            ])
          ]),
          _c("div", { staticClass: "feature-purple__media row" }, [
            _vm.lang != "ar"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: { src: require("assets/img/media/cnn_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: { src: require("assets/img/media/cbs_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: { src: require("assets/img/media/abc_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: { src: require("assets/img/media/nbc_logo.svg") }
                  })
                ])
              : _vm._e(),
            _vm.lang == "ar"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: {
                      src: require("assets/img/media/arabic/cnn_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: {
                      src: require("assets/img/media/arabic/alhayat_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: {
                      src: require("assets/img/media/arabic/youm_sabe3_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "feature-purple__logo",
                    attrs: {
                      src: require("assets/img/media/arabic/yahoo_maktoob_logo.png")
                    }
                  })
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "row" }, [
            _c("small", { staticClass: "col-12 feature-purple__disclaimer" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("trans")("st_public.media_disclaimer_message", {
                      websitename: _vm.websiteName
                    })
                  ) +
                  "\n      "
              )
            ])
          ])
        ])
      : _c("div", [
          _c("div", { staticClass: "row mt-3 mb-2" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h3", { staticClass: "h5" }, [
                _vm._v(_vm._s(_vm._f("trans")("st_public.featured_on")))
              ])
            ])
          ]),
          _c("div", { staticClass: "row pb-3" }, [
            _vm.lang != "ar"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: { src: require("assets/img/media/cnn_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: { src: require("assets/img/media/cbs_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: { src: require("assets/img/media/abc_logo.svg") }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: { src: require("assets/img/media/nbc_logo.svg") }
                  })
                ])
              : _vm._e(),
            _vm.lang == "ar"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: {
                      src: require("assets/img/media/arabic/cnn_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: {
                      src: require("assets/img/media/arabic/alhayat_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: {
                      src: require("assets/img/media/arabic/youm_sabe3_logo.png")
                    }
                  }),
                  _c("img", {
                    staticClass: "checkout-media-logo",
                    attrs: {
                      src: require("assets/img/media/arabic/yahoo_maktoob_logo.png")
                    }
                  })
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 text-muted small mt-2" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("trans")("st_public.media_disclaimer_message", {
                      websitename: _vm.websiteName
                    })
                  ) +
                  "\n      "
              )
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3da35fc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da35fc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeaturedOn.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3da35fc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeaturedOn.vue
// module chunks = 9 11